/**
 * Renders Denker's cursor during onboarding — standalone liquid cursor.
 *
 * Spec: docs/specs/2026-04-30-desktop-onboarding-design.md §3.2 + §3.4 reuse table
 */
import { AgentCursorArrow } from "@/components/cursors/agent-cursor-arrow";
import { useDenkerController } from "./denker-cursor-controller";
import {
  FLY_DURATION_MS,
  type Position,
} from "./denker-cursor-controller-types";

const DENKER_COLOR = "#30D158";

interface Props {
  position: Position;
  visible: boolean;
}

export function DenkerCursorRenderer({ position, visible }: Props) {
  const cursorAnim = useDenkerController((s) => s.cursorAnim);
  const cursorOpacity = useDenkerController((s) => s.cursorOpacity);

  if (!visible) return null;

  return (
    <div
      data-testid="denker-onboarding-cursor"
      data-cursor-anim={cursorAnim}
      style={{
        position: "fixed",
        left: position.x,
        top: position.y,
        pointerEvents: "none",
        zIndex: 9999,
        opacity: cursorOpacity,
        transition: `left ${FLY_DURATION_MS}ms cubic-bezier(0.25, 0.1, 0.25, 1), top ${FLY_DURATION_MS}ms cubic-bezier(0.25, 0.1, 0.25, 1), opacity 350ms ease-out`,
      }}
    >
      <AgentCursorArrow
        color={DENKER_COLOR}
        width={17}
        height={22}
        liquidLevel={0.18}
        mode="glass"
        shape="soft"
        tipTestId="denker-onboarding-cursor-tip"
      />
    </div>
  );
}
